import React from 'react';
import { useRoutes } from 'react-router-dom';
import { configResponsive } from 'ahooks';
import { GoogleOAuthProvider } from '@react-oauth/google';

import Notification from 'src/components/applications/Notification';
import CommandPalette from 'src/components/applications/CommandPalette';
import InstructionTour from 'src/components/applications/InstructionTour';
import routeConfig from 'src/routeConfig';
import { ENV } from 'src/env';

configResponsive({
  xs: 320,
  sm: 768,
  md: 992,
  lg: 1200,
  xl: 1920,
});

function App() {
  const routes = useRoutes(routeConfig);

  return (
    <GoogleOAuthProvider
      onScriptLoadError={console.error}
      onScriptLoadSuccess={console.info}
      clientId={ENV.GOOGLE_CLIENT_ID}
    >
      <CommandPalette>
        <InstructionTour>
          {routes}
          <Notification />
        </InstructionTour>
      </CommandPalette>
    </GoogleOAuthProvider>
  );
}

export default App;
